import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { createNameSpace } from 'lincd/utils/NameSpace';
import { linkedOntology } from '../package.js';
import * as _this from './rdfs.js';
let dataFile = '../data/rdfs.json';
export var loadData = () => {
    if (typeof module !== 'undefined' && typeof exports !== 'undefined') {
        // CommonJS import
        return import('../data/rdfs.json').then((data) => JSONLD.parse(data));
    }
    else {
        // ESM import
        //@ts-ignore
        return import('../data/rdfs.json', { with: { type: 'json' } }).then((data) => JSONLD.parse(data.default));
    }
};
export var ns = createNameSpace('http://www.w3.org/2000/01/rdf-schema#');
export var _self = ns('');
export var Class = ns('Class');
export var Datatype = ns('Datatype');
export var Literal = ns('Literal');
export var Resource = ns('Resource');
export var comment = ns('comment');
export var domain = ns('domain');
export var isDefinedBy = ns('isDefinedBy');
export var label = ns('label');
export var range = ns('range');
export var subClassOf = ns('subClassOf');
export var subPropertyOf = ns('subPropertyOf');
export const rdfs = {
    Class,
    Datatype,
    Literal,
    Resource,
    comment,
    domain,
    isDefinedBy,
    label,
    range,
    subPropertyOf,
    subClassOf,
};
linkedOntology(_this, ns, 'rdfs', loadData, dataFile);
//# sourceMappingURL=rdfs.js.map